module.exports = __webpack_public_path__ + "img/blogs_black.8be0cb6c.png";